/**
 * PDP (Product Detail Page) interaction tracking for GA4.
 * Tracks key user interactions on product pages.
 */
(function () {
  'use strict';

  function track(eventName, params) {
    try {
      if (typeof gtag !== 'function') return;
      gtag('event', eventName, params);
    } catch (e) { /* 静默失败 */ }
  }

  // 1. Gallery navigation (prev/next arrows, thumbnail clicks)
  document.addEventListener('click', function (e) {
    if (typeof gtag !== 'function') return;

    // Prev/Next arrows
    var arrow = e.target.closest('.splide__arrow');
    if (arrow) {
      var direction = arrow.classList.contains('splide__arrow--prev') ? 'prev' : 'next';
      track('pdp_gallery_nav', {
        direction: direction,
        image_index: ''
      });
      return;
    }

    // Thumbnail clicks
    var thumbnail = e.target.closest('.splide__thumbnail, .thumbnail-list__item');
    if (thumbnail) {
      var gallery = thumbnail.closest('.product__media-list, gallery-carousel');
      var activeSlide = gallery ? gallery.querySelector('.splide__slide.is-active') : null;
      var index = activeSlide ? activeSlide.dataset.mediaIndex || '' : '';
      track('pdp_gallery_nav', {
        direction: 'thumbnail',
        image_index: index
      });
      return;
    }

    // 2. Tab clicks (collapsible tabs)
    var tabButton = e.target.closest('.accordion summary');
    if (tabButton) {
      var tabTitle = tabButton.querySelector('.accordion__title');
      var tabName = tabTitle ? tabTitle.textContent.trim() : '';
      track('pdp_tab_click', {
        tab_name: tabName
      });
      return;
    }

    // 3. Related product clicks
    var relatedCard = e.target.closest('.related-products .card-wrapper, .recently-viewed .card-wrapper');
    if (relatedCard) {
      var heading = relatedCard.querySelector('.card__heading');
      var productName = heading ? heading.textContent.trim() : '';
      var position = relatedCard.dataset.position || '';
      track('pdp_related_click', {
        product_name: productName,
        position: position
      });
      return;
    }
  });

  // 4. Variant change tracking
  document.addEventListener('change', function (e) {
    if (typeof gtag !== 'function') return;

    var variantSelect = e.target.closest('.product-form__input select, .product-form__input input[type="radio"]');
    if (variantSelect) {
      var form = variantSelect.closest('.product-form__input');
      var label = form ? form.querySelector('.form__label') : null;
      var optionName = label ? label.textContent.split(':')[0].trim() : '';
      var optionValue = variantSelect.tagName === 'SELECT' ? variantSelect.value : variantSelect.value;
      track('pdp_variant_change', {
        option_name: optionName,
        option_value: optionValue
      });
    }
  });
})();
